"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockUserAccountSubscriber = void 0;
const events_1 = require("events");
class MockUserAccountSubscriber {
    constructor(userAccountPublicKey, data, slot) {
        this.isSubscribed = true;
        this.eventEmitter = new events_1.EventEmitter();
        this.userAccountPublicKey = userAccountPublicKey;
        this.user = { data, slot };
    }
    async subscribe(_userAccount) {
        return true;
    }
    async addToAccountLoader() { }
    async fetch() { }
    doesAccountExist() {
        return this.user !== undefined;
    }
    async unsubscribe() { }
    assertIsSubscribed() { }
    getUserAccountAndSlot() {
        return this.user;
    }
    updateData(userAccount, slot) {
        this.user = { data: userAccount, slot };
        this.eventEmitter.emit('userAccountUpdate', userAccount);
        this.eventEmitter.emit('update');
    }
}
exports.MockUserAccountSubscriber = MockUserAccountSubscriber;
